import React from "react";

import AboutPlan from "./about-plan";

const PlanInfo = (props) => {
  const {
    name_hy,
    name_en,
    name_ru,
    active,
    trial_period_days,
    max_inventory_items,
    max_inventory_items_ml,
    max_inventory_items_kg_pc,
    unlimited_items,
    actionHandler,
    actionStatusChange,
    loadingChangeStatus,
  } = props;

  return (
    <div className="plan_info_wrapper p-4">
      <AboutPlan
        name_hy={name_hy}
        name_en={name_en}
        name_ru={name_ru}
        active={active}
        trial_period_days={trial_period_days}
        max_inventory_items={max_inventory_items}
        max_inventory_items_ml={max_inventory_items_ml}
        max_inventory_items_kg_pc={max_inventory_items_kg_pc}
        unlimited_items={unlimited_items}
        actionHandler={actionHandler}
        actionStatusChange={actionStatusChange}
        loadingChangeStatus={loadingChangeStatus}
      />
    </div>
  );
};

export default PlanInfo;
